import React from 'react';
import {config, useSpring} from 'react-spring';

import EllipsisIcon from '@edna/icons/ellipsis.svg';

import * as S from './style';

export type TProps = {
  count: number;
  showAnimation?: boolean;
  className?: string;
};

const PULSE_DURATION = 2_000;

export const NotificationCounter = React.memo<TProps>(({className, count, showAnimation}) => {
  const ellipsisStyle = useSpring({
    loop: true,
    to: {scale: 1.5},
    from: {scale: 1},
    config: {...config.wobbly, duration: PULSE_DURATION},
  });

  const visibleCount = count > 99 ? '99+' : count;

  return (
    <S.NotificationCount className={className}>
      <S.Count hasBackground={!showAnimation}>{visibleCount}</S.Count>
      {showAnimation && (
        <S.EllipsisWrapper style={ellipsisStyle}>
          <EllipsisIcon />
        </S.EllipsisWrapper>
      )}
    </S.NotificationCount>
  );
});
